// extracted by mini-css-extract-plugin
export var ctaButton = "CtaButton-module--ctaButton--27511";
export var primary = "CtaButton-module--primary--ecd4c";
export var secondary = "CtaButton-module--secondary--1ab30";
export var teritiary = "CtaButton-module--teritiary--700b1";
export var transparent = "CtaButton-module--transparent--c5b04";
export var wideBtn = "CtaButton-module--wideBtn--197e5";